import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise, AxiosRequestConfig } from 'axios'
import { ResponseData } from 'request'
import { cookRequestParams } from '@/common/request'
import {
  CreateOrderParams,
  CreateOrderResponse,
  GrantOrderCostPayload,
  GrantOrderCostResponse,
  GrantOrderStatusResponse,
} from './index.type'

/**
 * 资源列表
 */
export function getGrantOrderStatus(
  data: { id: string },
  config?: AxiosRequestConfig,
): AxiosPromise<ResponseData<GrantOrderStatusResponse>> {
  return request({
    url: `${v2Host}/buy/order-status`,
    method: 'get',
    params: cookRequestParams(data),
    ...config,
  })
}

/**
 * 计算加油包购买订单金额
 */
export function calOrderCost(data: {
  payload: GrantOrderCostPayload
}): AxiosPromise<ResponseData<GrantOrderCostResponse>> {
  return request({
    url: `${v2Host}/buy/cal-order-cost`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

/**
 * 创建订单
 */
export function createOrder(
  data: CreateOrderParams,
): AxiosPromise<ResponseData<CreateOrderResponse>> {
  return request({
    url: `${v2Host}/buy/create-order`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}

/**
 * 重新支付
 */
export function repayOrder(
  data: Pick<CreateOrderResponse, 'order_id'>,
): AxiosPromise<ResponseData<CreateOrderResponse>> {
  return request({
    url: `${v2Host}/user/order/repay`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data,
  })
}
